<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {delay, navigate} from "src/components/cabinet/#common/helpers"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import Editor from '@tinymce/tinymce-svelte'
    import {createArticle} from 'src/components/cabinet/#services/blogArticles'
    import {getAllCategories} from 'src/components/cabinet/#services/blogCategories'
    import mainImagePlaceholder from './main-image.jpg'
    import {DataType} from 'src/services/api/common/http/HttpApi'
    import {api} from 'src/services/api/reallis'

    getAllCategories.send();

    let saved = false
    $: title = ''
    $: shortDescription = ''
    let image
    let tempImage = ''
    let content = ''
    $: url = ''
    $: metaTitle = ''
    $: metaDescription = ''
    $: categoryId = ''

    const images_upload_handler = (blobInfo, _) => new Promise(async (resolve, reject) => {
        try {
            let response = await api.http.request({
                method: 'post',
                url: process.env.IMAGE_UPLOAD_URL + 'blog',
                dataType: DataType.MultipartFormData,
                data: { image: blobInfo.blob() }
            });
            resolve(`${process.env.IMAGES_PATH}${response.data?.location}`);
        } catch (err) {
            reject('An Error Occurred, Please Try Again Later');
        }
    });

    let conf = {
        apiKey: "575wkjbaqgl2wp1rjkca9tdq4mg9k5b0xkruqqdg25p375c3",
        plugins: 'link code lists advlist quickbars image editimage media mediaembed',
        toolbar: 'undo redo | bold italic underline strikethrough h2 h3 blockquote | link quickimage editimage media | alignleft aligncenter alignright alignjustify | bullist numlist | code',
        menubar: false,
        relative_urls: false,
        remove_script_host: false,
        quickbars_insert_toolbar: false,
        link_assume_external_targets: true,
        quickbars_image_toolbar: 'alignleft aligncenter alignright',
        automatic_uploads: true,
        images_upload_handler
    }

    let imageInput;

    async function onFileSelected(imageFile) {
        try {
            let response = await api.http.request({
                method: 'post',
                url: process.env.IMAGE_UPLOAD_URL+'blog',
                dataType: DataType.MultipartFormData,
                data: { image: imageFile }
            })
            image = response.data?.location
        } catch (err) {
            showAlert.set({
                status: 'error',
                text: 'An Error Occurred, Please Try Again Later'
            })
        }
    }

    async function create() {
        saved = true

        if (title !== '' &&
            shortDescription !== '' &&
            image !== '' &&
            content !== '' &&
            url !== '' &&
            metaTitle !== '' &&
            metaDescription !== '' &&
            categoryId !== ''
        ) {
            try {
                await createArticle.request({
                    data: {
                        props: {
                            title,
                            shortDescription,
                            image,
                            content,
                            url,
                            metaTitle,
                            metaDescription,
                            lang: 'en',
                        },
                        categoryId,
                    }
                })

                showAlert.set({
                    status: 'success',
                    text: 'Article successfully created!'
                })

                setTimeout(function () {
                    navigate("/blog");
                }, 500)
            } catch (e) {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }
</script>

<svelte:head>
    <title>Create article</title>
</svelte:head>

<MainLayout title="Create article">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="blog" class="btn btn-primary mb-3">Back</Link>
                <div class="row mb-3">
                    <div class="col-lg-8">
                        <div class="form-group mb-3">
                            <label>Title</label>
                            <input type="text" class="form-control" bind:value={title}
                               class:is-invalid={saved && title === ''}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Short Description</label>
                            <textarea class="form-control" bind:value={shortDescription}
                                class:is-invalid={saved && shortDescription === ''}></textarea>
                        </div>
                        <div class="form-group mb-3">
                            <label>Main image</label><br>
                            <label>
                                <input type="file" class="form-control" class:is-invalid={saved && !image} accept=".jpg, .jpeg, .png, .gif" on:change={(e) => onFileSelected(e.target.files[0])}>
                                {#if image}
                                    <img class="main-image-thumb" src="{process.env.IMAGES_PATH+image}" alt=""/>
                                {:else}
                                    <img class="main-image-thumb" src="{mainImagePlaceholder}" alt=""/>
                                {/if}
                            </label>
                        </div>
                        <div class="form-group mb-3">
                            <label>Content</label>
                            <Editor
                                scriptSrc="/js/tinymce.min.js"
                                api-key="575wkjbaqgl2wp1rjkca9tdq4mg9k5b0xkruqqdg25p375c3"
                                bind:value={content}
                                {conf}
                            />
                            <span class="help-block text-danger" class:d-block={saved && content === ''}
                                style="display: none;">Enter content</span>
                        </div>
                        <div class="form-group mb-3">
                            <label>Meta Title (70-80 characters)</label>
                            <input type="text" class="form-control" bind:value={metaTitle}
                                class:is-invalid={saved && metaTitle === ''}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Meta Description (170-250 characters)</label>
                            <textarea class="form-control" bind:value={metaDescription}
                                class:is-invalid={saved && metaDescription === ''}></textarea>
                        </div>
                        <div class="form-group mb-3">
                            <label>URL</label>
                            <div class="input-group">
                                <span class="input-group-text">{process.env.BLOG_URL}</span>
                                <input type="text" class="form-control" bind:value={url}
                                    class:is-invalid={saved && url === ''}>
                            </div>
                        </div>
                        {#if metaTitle && metaDescription}
                        <div class="form-group mb-3">
                            <label>Google preview</label>
                            <div class="google-meta-preview">
                                <div class="google-meta-title">{metaTitle}</div>
                                <div class="google-meta-url">https://realis.network/blog/{url}</div>
                                <div class="google-meta-description">{metaDescription}</div>
                            </div>
                        </div>
                        {/if}
                        <div class="form-group mb-3">
                            <label>Category</label>
                            {#if !$getAllCategories.hasValue && $getAllCategories.loading}
                                <select class="form-select" disabled>
                                    <option selected>Loading...</option>
                                </select>
                            {:else if !$getAllCategories.hasValue && $getAllCategories.error }
                                <select class="form-select" disabled>
                                    <option selected>Something went wrong</option>
                                </select>
                            {:else if $getAllCategories.value}
                                <select class="form-select" bind:value={categoryId}
                                    class:is-invalid={saved && categoryId === ''}>
                                    <option value="0" selected disabled>Select category</option>
                                    {#each $getAllCategories.value as { id, name }}
                                        <option value={id}>{name.replace('|', '')}</option>
                                    {/each}
                                </select>
                            {/if}
                        </div>
                    </div>
                </div>
                <button class="btn btn-success" on:click={create}>Create</button>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .input-group-text {
        height: 38px;
        font-size: 14px;
        color: #296bff;
    }

    textarea {
        resize: none;
    }

    .main-image-thumb {
        border: 1px solid #ced4da;
        height: 100px;
        margin: 15px 0 0;
        padding: 5px;
        border-radius: 0.25rem;
        cursor: pointer;
    }

    .google-meta-preview {
        width: 600px;
        border: 1px solid #c7c7c7;
        padding: 10px 14px;
        border-radius: 5px;
        font-family: Arial;
        background: white;
    }

    .google-meta-title {
        font-size: 20px;
        line-height: 1.3;
        color: #1a0dab;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .google-meta-url {
        padding-bottom: 1px;
        color: #006621;
        font-size: 16px;
        line-height: 1.5;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .google-meta-description {
        line-height: 1.57;
        word-wrap: break-word;
        color: #545454;
    }
</style>
